import { render } from "./UpdateUser.vue?vue&type=template&id=43079a3e"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__